import { Button, Col, Menu, Row, Tooltip, Badge, message } from "antd";
import { Header } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { signOut } from "../redux/actions/authAction";
;
import {
  AlignCenterOutlined,
  EditOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  LogoutOutlined,
  SyncOutlined,
  BellOutlined,
  GlobalOutlined
} from "@ant-design/icons";
import default_image from "../assets/images/default-user-image.jpg";
import ImageDropdown from "../components/specificComponents/ImageDropdown";
import { MdMenuOpen } from "react-icons/md";
import { DAY_SHIFT_TERMINAL, DISPATCHER } from "../common/SetupMasterEnum";
import "./style.css";
import {
  HubConnectionBuilder,
  LogLevel,
  HttpTransportType,
} from "@microsoft/signalr";
import { playNotificationSound } from "../functions/generalFunctions";
import NewOrdersModal from "../components/PosComponentsFood/NewOrdersModal";
import { postRequest } from "../services/mainApp.service";
import UnlockAudioModal from "../components/NewComponents/UnlockAudioModal";
import packageJson from "../../package.json";
import {
  CASHIER,
  CALL_CENTER_ADMIN,
  AGENT,
  SUPER_ADMIN,
  COMPANY_ADMIN,
  WEB_ORDERING
} from "../../src/common/SetupMasterEnum";
const HeaderLayout = React.memo(({ toggleCollapse, collapsable }) => {
  const APP_VERSION = process.env.REACT_APP_VERSION || packageJson.version;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    CompanyName,
    Name,
    online,
    userBranchList,
    RoleId,
    UserName,
    CompanyId,
    UserId,
    WebsiteUrl
  } = useSelector((state) => state.authReducer);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [hubConnection, setHubConnection] = useState(null);
  const [messages, setMessages] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [pendingOrderCount, setPendingOrderCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  // new Orders data
  const [newOrders, setNewOrders] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);

  const websiteUrl = localStorage.getItem("WebsiteUrl");

  const { RefreshStats } = useSelector((state) => state.RefreshReducer);

  // Callback function to update newOrders
  const handleOrdersUpdate = (updatedOrders) => {
    setNewOrders(updatedOrders); // Update the state in the parent
  };

  useEffect(() => {
    if (localStorage.getItem(DAY_SHIFT_TERMINAL))
      setDate(
        new Date(
          JSON.parse(localStorage.getItem(DAY_SHIFT_TERMINAL)).Date
        ).toLocaleDateString()
      );
  }, [localStorage.getItem(DAY_SHIFT_TERMINAL)]);


  useEffect(() => {
    if (RoleId !== AGENT) {
      const interval = setInterval(() => {
        if (pendingOrderCount >= 1) {
          playNotificationSound();
        }
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [pendingOrderCount]);


  useEffect(() => {

    if (RefreshStats == 1) {
      fetchNewOrders(true);
      dispatch({ type: "REFRESH_STATS", payload: 0 });
    }
  }, [RefreshStats]);


  const Logout = async () => {
    try {
      if (hubConnection) {
        await hubConnection.stop();
        // console.log("🔌 SignalR connection stopped.");
      }
    } catch (error) {
      console.error("Failed to stop SignalR:", error);
    }

    dispatch(signOut(navigate));
  };

  const toggleNetwork = (network) =>
    dispatch({ type: "TOGGLE_NETWORK", payload: network });

  const fetchNewOrders = (isInitial = false) => {
    postRequest("GetOrder", {
      OperationId: 1,
      UserIP: "12.1.1.2",
      BranchId: null,
      AreaId: null,
      StatusId: -1,
      OrderNumber: "%%",
      CustomerName: "%%",
      CustomerPhone: "%%",
      DateFrom: null,
      DateTo: null,
      CityId: null,
      CompanyId: CompanyId,
      userId: UserId,
      OrderModeId: null,
      OrderSourceId: null,
    })
      .then((response) => {
        if (response.data.error === true) {
          message.error(response.data.errorMessage);
          return;
        }

        if (response.data.response === false) {
          message.error(response.data.DataSet.Table.errorMessage);
          return;
        }

        const data = response.data.DataSet;
        const { Table13, Table2 } = data;
        setNewOrders(Table13 || []);
        setOrderStatusList(Table2 || []);
        if (!isInitial) {
          setIsOpen(true);
        }

        //  // Prevent re-render for pending orders
        //  setPendingOrderCount((prevCount) => {
        //   const newCount = Table13?.length || 0;
        //   return prevCount !== newCount ? newCount : prevCount;
        // });


        setPendingOrderCount(Table13?.length || 0);


      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  useEffect(() => {
    if (UserId && CompanyId) {
      fetchNewOrders(true);
    }

    SignalRConnection();

    // if (RoleId !== AGENT) {
    //   SignalRConnection();
    // }

  }, [UserId, CompanyId]); // Depend on UserId & CompanyId


  const SignalRConnection = async () => {
    let connection;
    if (!isConnected) {
      // const url = REACT_APP_BASEURL+'/orderHub';
      connection = new HubConnectionBuilder()
        .withUrl(process.env.REACT_APP_BASEURL + `/orderHub`, {
          skipNegotiation: true,
          transport: HttpTransportType.WebSockets,
        }) // Pass companyId as query string
        .configureLogging(LogLevel.Information)
        .withAutomaticReconnect()
        .build();
    }

    /*
    connection.on("ReceiveOrderUpdate", (orderCount) => {
      setPendingOrderCount((prevCount) => {
        dispatch({ type: "REFRESH_STATS", payload: 1 });

        if (orderCount > prevCount && orderCount > 0) {
          playNotificationSound();
        }
        return orderCount; 
      });
    });
    */

    connection.on("ReceiveOrderUpdate", (jsonData) => {


      dispatch({ type: "REFRESH_STATS", payload: 1 });

      const orderList = JSON.parse(jsonData);

      if (
        RoleId === SUPER_ADMIN ||
        RoleId === COMPANY_ADMIN ||
        RoleId === AGENT ||
        RoleId === CALL_CENTER_ADMIN ||
        RoleId === WEB_ORDERING
      ) {
        const totalOrderCount = (orderList || [])
          .reduce((sum, order) => sum + (+order.OrderCount || 0), 0);

        setPendingOrderCount(totalOrderCount);
        if (totalOrderCount > 0 && (RoleId != AGENT && RoleId != CALL_CENTER_ADMIN)) {
          playNotificationSound();
        }
      }
      else {
        const totalOrderCount = orderList
          .filter(order => userBranchList.some(branch => branch.BranchId === order.BranchId))
          .reduce((sum, order) => sum + (order.OrderCount || 0), 0);

        setPendingOrderCount(totalOrderCount);

        if (totalOrderCount > 0 && (RoleId != AGENT && RoleId != CALL_CENTER_ADMIN)) {
          playNotificationSound();
        }
      }
    });



    if (!isConnected) {
      try {
        var companyId = CompanyId;
        await connection.start();
        var result = connection.send("RegisterConnection", CompanyId);
        // console.log("checking result of connection from singal R....", result);
        setHubConnection(connection);
        setIsConnected(true);
        // console.log("Connected to SignalR with Company ID:", CompanyId);
      } catch (error) {
        console.error("Connection failed: ", error);
      }
    }
  };

  const menu = (
    <Menu>
      <Menu.Item
        key="1"
        icon={<EditOutlined />}
        onClick={() => navigate("changepassword")}>
        Change Password
      </Menu.Item>
      <Menu.Item key="2" icon={<LogoutOutlined />} onClick={Logout}>
        Sign Out
      </Menu.Item>
    </Menu>
  );

  function checkTime(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  return (
    <Header className="mainHeader">
      <UnlockAudioModal />
      <Row justify="center">
        <Col
          // span={9}
          xs={18}
          sm={9}
          className="header-col"
          style={{
            justifyContent: "flex-start",
          }}
          align="left">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
              height: 57,
              color: "white",
            }}>
            <Button
              type="text"
              onClick={toggleCollapse}
              icon={
                <MdMenuOpen
                  style={{
                    fontSize: 28,
                    transform: collapsable && "scaleX(-1)",
                    transition: "0.2s",
                  }}
                />
              }
              className="sidebarButton"
              style={{ marginRight: 20 }}
            />
            v{APP_VERSION}
          </div>
        </Col>
        <Col
          span={6}
          className="header-col headerCompanyName flex items-center justify-center">
          <h2 style={{ margin: 0 }} className="text-3xl flex items-center gap-2">
            <b>{CompanyName} </b>

            {/* 
              <a
                href={websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-blue-300 text-lg font-medium">
              
                <GlobalOutlined className="text-5xl" />
              </a> 
            */}

          </h2>
        </Col>
        <Col
          span={3}
          className="header-col headerCompanyName"
          style={{
            justifyContent: "center",
          }}
          align="center">
          <span
            style={{
              fontSize: 12,
              fontWeight: 600,
              opacity: 0.9,
              whiteSpace: "nowrap",
            }}
          >

          </span>
        </Col>
        <Col xs={3} sm={6} align="right">
          <Row
            align="right"
            style={{
              height: 57,

              justifyContent: "flex-end",
            }}>
            {/* <h3 className="timeStyle">{date}</h3>
            <h3 className="timeStyle">{time}</h3> */}



            &nbsp;
            &nbsp;
            &nbsp;


            {RoleId !== AGENT &&
              <>
                <Badge
                  count={pendingOrderCount}
                  overflowCount={999}
                  size="large"
                  className="mt-3"
                >
                  <Button
                    type="danger"
                    icon={
                      pendingOrderCount > 0 ? (
                        <BellOutlined className="animate-shake bell_icon" />
                      ) : null
                    } // ✅ Explicitly check if pendingOrderCount > 0
                    size="large"
                    className="flex items-center justify-center rounded-lg text-xl bg-red-500 h-10"
                    onClick={() => fetchNewOrders()}
                  >
                    {
                      pendingOrderCount > 0 ? pendingOrderCount === 1 ? "New Order" : "New Orders" : "No Orders"
                    }
                  </Button>
                </Badge>
                <NewOrdersModal
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  newOrders={newOrders}
                  onUpdateOrders={handleOrdersUpdate} // Pass the callback to the child
                  orderStatusList={orderStatusList}
                />
              </>
            }


            <div className="mt-[6px] ml-4">
              <ImageDropdown
                title={Name}
                menu={menu}
                DisplayText={UserName?.substring(0, 1).toUpperCase()}
              />
            </div>


          </Row>
        </Col>
      </Row>
    </Header>
  );
});

export default HeaderLayout;
